import { GalleryWrapper } from './styles'

interface GalleryProps {
    children: React.ReactNode
    hasAlternativeLayout?: boolean
}

const Gallery = ({ children, hasAlternativeLayout }: GalleryProps) => (
    <GalleryWrapper
        gap={16}
        columns={[1, 2]}
        hasAlternativeLayout={hasAlternativeLayout}
    >
        {children}
    </GalleryWrapper>
)

export default Gallery
